var _line, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 67,
    viewBox: "0 0 64 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.548825,
    y1: 39.0254,
    x2: 63.4512,
    y2: 39.0254,
    stroke: "#828282",
    strokeWidth: 1.09765,
    strokeLinecap: "round",
    strokeDasharray: "2.2 2.2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51953 39.492C7.13384 29.026 9.04937 6.82501 11.797 1.74861C11.8249 1.44645 12.0818 2.01232 12.886 6.69316C13.64 16.0054 15.1311 35.6023 15.064 39.492C15.5387 46.744 16.9405 62.1215 18.7499 65.6157C19.0291 65.8904 19.8389 65.4509 20.8441 61.4952C21.989 53.7213 24.8986 37.7284 27.3782 35.9484C28.523 34.7397 31.0138 33.8552 31.818 39.9865C32.0413 41.9643 32.9237 45.854 34.6661 45.5903C35.2804 45.6727 37.129 44.5025 39.6085 39.1624C40.5579 37.4318 43.2944 35.2232 46.6452 40.2337C48.4602 42.5686 53.3635 45.8375 58.4567 40.2337",
    stroke: "#66FCF1",
    strokeWidth: 2.42759,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartA);
export default __webpack_public_path__ + "static/media/chartA.f12ef5266c753de9dc0cffa4bce933fe.svg";
export { ForwardRef as ReactComponent };